module.exports = __webpack_public_path__ + "spine/Farm_Guy.json?d931c1025d97012c2159447d11176bb8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/citizens/man/Farm_Guy.json
// module id = 1748
// module chunks = 3